import { render, staticRenderFns } from "./questionCircleIcon.vue?vue&type=template&id=4bf15dd6&"
import script from "./questionCircleIcon.vue?vue&type=script&lang=js&"
export * from "./questionCircleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports